import React, { useEffect, useRef } from 'react';

/** Muted autoplay preview for dock / profile (same behavior as profile self camera). */
export function DockLocalVideoPreview({ stream, enabled }: { stream: MediaStream | null; enabled: boolean }) {
  const ref = useRef<HTMLVideoElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) {
      return;
    }
    if (enabled && stream) {
      el.srcObject = stream;
      void el.play().catch(() => {});
    } else {
      el.srcObject = null;
    }
  }, [enabled, stream]);
  if (!enabled || !stream) {
    return (
      <div className="flex h-full min-h-[120px] items-center justify-center text-gray-500 text-sm">Camera off</div>
    );
  }
  return <video ref={ref} autoPlay playsInline muted className="h-full w-full object-cover" />;
}
